import HttpClient from '../services/HttpClient';
import { APP_URL_CONTRACT, CLAUSE, CLAUSE_RAIZ, CONTRACTTYPE, } from '../constants'

export const getClauses = (filters, paginator) => {
    return new Promise((resolve, reject) => {
        const headers = {
            'Content-Type': 'application/json'
        };

        HttpClient.post(`${APP_URL_CONTRACT}${CLAUSE}?page=${paginator.page}&size=${paginator.size}&order=${paginator.order}&columnOrder=${paginator.columnOrder}`, filters, headers).then(response => {
            resolve(response);
        }).catch(error => {
            if (typeof error.response === 'undefined') {

                reject({ error: 'technical_error', error_description: 'Occurió un problema comuniquese con el administrador.' });
            }
            reject(error.response);
            resolve(error.response);
        });
    });
}

export const getContractTypeFormat = (data) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    let filters = "";
    if (data?.status && data?.contractType) {
      filters = `?status=${data.status}&contractType=${data.contractType}`;
    } else if (data?.status) {
      filters = `?status=${data?.status}`;
    } else if (data?.contractType) {
      filters = `?contractType=${data?.contractType}`;
    }

    HttpClient.get(`${APP_URL_CONTRACT}${CONTRACTTYPE}${filters}`, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {

          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const postClause = (body, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(`${APP_URL_CONTRACT}${CLAUSE_RAIZ}`, body, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

//sin uso
export const getContractType = () => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(`${APP_URL_CONTRACT}/contract-type`, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {

          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const editClause = (data) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.put(`${APP_URL_CONTRACT}${CLAUSE_RAIZ}`, data, headers)
      .then((response) => {
        resolve(response);
      }).catch((error) => {
        resolve(error.response);
      });
  });
};

export const getAllClauses = (paginator) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };

    HttpClient.post(
      `${APP_URL_CONTRACT}${CLAUSE}?page=${paginator.page}&size=${paginator.size}&order=${paginator.order}&columnOrder=${paginator.columnOrder}`,
      {},
      headers
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {

          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};

//sin uso
export const getActiveContractTypeFormat = () => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };

    HttpClient.get(`${APP_URL_CONTRACT}${CONTRACTTYPE}?status=Activo`, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {

          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};
